import React from 'react';
import { Form } from '@douyinfe/semi-ui';
import AvatarSelector from '../../components/AvatarSelector';
import { SingleTextStyleForm } from '../../components/SingleText';
import { MultiTextStyleForm } from '../../components/MultiText';
import ColorPicker from '../../../ColorPicker';
import { ModuleStyleForm } from '../../components/ModuleBase/ModuleBase';

export const GroupInfoStyleForm = ({ data = {}, onChange }) => {
    const defaultData = {
        title: '用户名',
        titleStyle: {
            fontSize: '16px',
            color: '#1C1F23'
        },
        avatar: '',
        likes: 0,
        description: '评论内容',
        descriptionStyle: {
            fontSize: '14px',
            color: '#666666'
        },
        avatarSize: 64,
        avatarBorderRadius: '50%',
        likeIconColor: '#666666',
        likeIconSize: 16,
        style: {}
    };

    const handleTitleChange = (titleData) => {
        onChange?.({
            ...defaultData,
            ...data,
            title: titleData.text,
            titleStyle: titleData.style
        });
    };

    const handleDescriptionChange = (descriptionData) => {
        onChange?.({
            ...defaultData,
            ...data,
            description: descriptionData.text,
            descriptionStyle: descriptionData.style
        });
    };

    return (
        <Form
            labelPosition="left"
            labelAlign="right"
            initValues={{
                likes: data?.likes ?? defaultData.likes,
                avatarSize: data?.avatarSize || defaultData.avatarSize,
                avatarBorderRadius: data?.avatarBorderRadius || defaultData.avatarBorderRadius,
                likeIconSize: data?.likeIconSize || defaultData.likeIconSize
            }}
            onValueChange={(values) => {
                onChange?.({ ...defaultData, ...data, ...values });
            }}
        >
            <div >
                <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '12px' }}>
                    <SingleTextStyleForm
                        data={{
                            text: data?.title || defaultData.title,
                            style: data?.titleStyle || defaultData.titleStyle
                        }}
                        onChange={handleTitleChange}
                    />
                    <MultiTextStyleForm
                        data={{
                            text: data?.description || defaultData.description,
                            style: data?.descriptionStyle || defaultData.descriptionStyle
                        }}
                        onChange={handleDescriptionChange}
                    />
                    <Form.Slot>
                        <AvatarSelector
                            field="avatar"
                            size={data?.avatarSize || defaultData.avatarSize}
                            borderRadius={data?.avatarBorderRadius || defaultData.avatarBorderRadius}
                            value={data?.avatar || defaultData.avatar}
                            onChange={(value) => {
                                onChange?.({ ...defaultData, ...data, avatar: value });
                            }}
                            onSizeChange={(value) => {
                                onChange?.({ ...defaultData, ...data, avatarSize: value });
                            }}
                            onBorderRadiusChange={(value) => {
                                onChange?.({ ...defaultData, ...data, avatarBorderRadius: value });
                            }}
                        />
                    </Form.Slot>
                    <Form.InputNumber
                        field="likes"
                        label="点赞数量"
                        style={{ width: '100%' }}
                        min={0}
                    />
                    <Form.Slot label="点赞图标颜色">
                        <ColorPicker
                            value={data?.likeIconColor || defaultData.likeIconColor}
                            onChange={(value) => {
                                onChange?.({ ...defaultData, ...data, likeIconColor: value });
                            }}
                        />
                    </Form.Slot>
                    <Form.InputNumber
                        field="likeIconSize"
                        label="点赞图标大小"
                        style={{ width: '100%' }}
                        min={12}
                        max={32}
                        suffix="px"
                    />
                </div>
                <ModuleStyleForm
                    style={data?.style || {}}
                    onChange={(style) => {
                        onChange?.({ ...defaultData, ...data, style });
                    }}
                />
            </div>
        </Form>
    );
};

export default GroupInfoStyleForm;